import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from '../../PaxSelector';

export const DpPaxMessages = ({ kids, restrictions }) => {
    const showMaxKidsRoom = kids >= restrictions.maxKidsPerAdult;
    return (
        <>
            {showMaxKidsRoom && (
                <ErrorMessage
                    messages={[{
                        key: 'guestSelector.children.max',
                        values: { number: restrictions.maxKidsPerAdult }
                    }]}
                />
            )}
        </>
    );
};
DpPaxMessages.propTypes = {
    kids: PropTypes.number.isRequired,
    restrictions: PropTypes.object.isRequired
};
